export default __webpack_public_path__ + "static/media/Gauntlets of the Vanguard.e6b0e93c.jpg";